module.exports = __webpack_public_path__ + "static/media/orange_n_black.def0587c.jpeg";